import OperationsDriverPerformance from "../../components/Operations/DriverPerformance/OperationsDriverPerformance";

const OperationsDriverPerformancePage = () => {
  return <OperationsDriverPerformance />;
};

export default OperationsDriverPerformancePage;
